import React, { useState, useContext } from "react";
import clsx from "clsx";
import { useNavigate, Link } from "react-router-dom";
import ReactPlayer from "react-player";

import Popup from "../../../../components/popup";
import Button from "../../../../components/button";
import { VideoPlayer } from "../../../../components/video-player";
import { AppSettingsContext } from "../../../../App";

import {
  NOMINATE,
  ULTIMATE_FOUNDERS,
  VIEW,
  VOTE,
} from "../../../../constants/common";

import styles from "./third-section.module.scss";
import { AnimatedContent } from "../../../../components/animated-content";

export function getTitles({
  sitePhase,
  nominationText,
  compilingText,
  votesText,
  choosingText,
  winnersText,
  nomitationYear,
}) {
  const actualizeText = (txt) => {
    return !!(txt && nomitationYear)
      ? txt.replace("_YEAR_", nomitationYear)
      : txt;
  };
  switch (sitePhase) {
    case "Nomination":
      return {
        page: ULTIMATE_FOUNDERS,
        action: NOMINATE,
        url: "/share-your-story",
        text: actualizeText(nominationText),
      };
    case "Compiling":
      return {
        page: ULTIMATE_FOUNDERS,
        action: null,
        url: null,
        text: actualizeText(compilingText),
      };
    case "Voting":
      return {
        page: ULTIMATE_FOUNDERS,
        action: VOTE,
        url: "/vote-for-ultimate-founders",
        text: actualizeText(votesText),
      };
    case "Choosing":
      return {
        page: ULTIMATE_FOUNDERS,
        action: null,
        url: "/vote-for-ultimate-founders",
        text: actualizeText(choosingText),
      };
    default: //"Selection"
      return {
        page: ULTIMATE_FOUNDERS,
        action: VIEW,
        url: "/ultimate-founders-winners",
        text: actualizeText(winnersText),
      };
  }
}

export const ThirdSection = ({
  nominationText,
  compilingText,
  votesText,
  choosingText,
  winnersText,
  legacyRadioUrl,
}) => {
  const navigate = useNavigate();
  const [hovered, setHovered] = useState(false);
  const [showScrapBook, setShowScrapBook] = useState(false);
  const [showAudioRadio, setShowAudioRadio] = useState(false);

  const {
    site_phase: sitePhase,
    global_newsletter_sent: newsletterSent,
    nomination_year: nomitationYear,
  } = useContext(AppSettingsContext);

  const { page, action, url, text } = getTitles({
    sitePhase,
    nominationText,
    compilingText,
    votesText,
    choosingText,
    winnersText,
    nomitationYear,
  });

  return (
    <div
      id="global_activation_boxes"
      data-testid="ThirdSection"
      className={clsx(styles.root, {
        [styles.hovered]: hovered,
      })}
    >
      {sitePhase !== "Choosing" && sitePhase !== "Selection" && (
        <div
          className={
            newsletterSent
              ? `${styles.wrapper} ${styles.isCompilingWrapper}`
              : styles.wrapper
          }
        >
          {newsletterSent &&
            (sitePhase === "Voting" || sitePhase === "Choosing") && (
              <AnimatedContent rootMargin={10} threshold={0.05}>
                <div className={styles.compilingPhaseImages}>
                  <a
                    title="Created by Primos for Primos, our global digital scrapbook will serve as a collection of memories capturing major moments, both collective and individual, shaping our legacy today and into the future.
              Share your moments! Upload up to 5 images and a short description that captures your #BacardiLife by Thursday, January 18."
                    className={styles.compilingImgWrap}
                    href="https://forms.office.com/r/mRHYkNGRYe"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <div
                      className={`${styles.compilingPhaseImg} ${styles.compilingPhaseImgScrapbook}`}
                    />
                  </a>

                  <a
                    title="Featuring soundbites and song requests, Legacy Radio will use music to connect us. Send in your “Legacy Track” by Thursday, January 18 for a chance to be included in this 2-hour cultural music mix – tell us why the track is so special, how it makes you feel – all while inspiring Primos around the world."
                    className={styles.compilingImgWrap}
                    href="https://forms.office.com/r/WvTqzVpu05"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <div
                      className={`${styles.compilingPhaseImg} ${styles.compilingPhaseImgRadio}`}
                    />
                  </a>

                  <a
                    title="We invite you to make it personal. Share your celebratory photo and let us transform you into the hero of your very own cocktail adventure. Picture this: you are splashing into a Gin & Tonic, striking a superhero pose by a Mojito, or relaxing poolside with a Margarita. Let our designers work their magic. Run, don’t walk - the first 162 Primos to submit their photo by Thursday, January 18 will receive a bespoke poster to print or use digitally."
                    className={styles.compilingImgWrap}
                    href="https://forms.office.com/r/K84s38Dhkt"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <div
                      className={`${styles.compilingPhaseImg} ${styles.compilingPhaseImgPosters}`}
                    />
                  </a>

                  {sitePhase === "Voting" && (
                    <a
                      title="Recognize Primos making a big difference at Bacardi by casting your votes for the Ultimate Founders Competition. The judges have narrowed down the nominations and selected 17 remarkable Primos for the shortlist. Read their stories "
                      className={styles.compilingImgWrap}
                      href="https://foundersday.bacardi.com/vote-for-ultimate-founders"
                    >
                      <div
                        className={`${styles.compilingPhaseImg} ${styles.compilingPhaseImgUFC}`}
                      />
                    </a>
                  )}
                  {sitePhase === "Choosing" && (
                    <div className={styles.compilingImgWrap}>
                      <div
                        className={`${styles.compilingPhaseImg} ${styles.compilingPhaseImgUFCRevealedSoon}`}
                      />
                    </div>
                  )}

                  <div
                    title="Spot the palm tree! We will strategically “plant” digital palm trees across our internal platforms. A riddle will be released per day starting January 29 through February 1, and it’s up to you to find the location and submit your findings in the correct order to be up for winning a prize. The winners will be randomly selected for those that provide the correct sequence. Happy palm tree spotting!"
                    className={styles.compilingImgWrap}
                  >
                    <div
                      className={`${styles.compilingPhaseImg} ${styles.compilingPhaseImgQuest}`}
                    />
                  </div>

                  <div
                    title="Creative assets will be available for you to download on Founder’s Week, kicking off January 29 through February 2. Here you’ll find everything from branded PowerPoint templates, Microsoft Teams backgrounds, and more!"
                    className={styles.compilingImgWrap}
                  >
                    <div
                      className={`${styles.compilingPhaseImg} ${styles.compilingPhaseImgAssets}`}
                    />
                  </div>
                </div>
              </AnimatedContent>
            )}

          {newsletterSent && sitePhase === "Selection" && (
            <AnimatedContent rootMargin={10} threshold={0.05}>
              <div className={styles.compilingPhaseImages}>
                <div
                  onClick={() => setShowScrapBook(true)}
                  style={{ cursor: "pointer" }}
                  // onClick={() => {}}
                  className={styles.compilingImgWrap}
                >
                  <div
                    className={`${styles.compilingPhaseImg} ${styles.selectionPhaseImgScrapbook}`}
                  />
                </div>
                <div
                  className={styles.compilingImgWrap}
                  onClick={() => setShowAudioRadio(true)}
                  style={{ cursor: "pointer" }}
                  // onClick={() => {}}
                >
                  <div
                    className={`${styles.compilingPhaseImg} ${styles.selectionPhaseImgRadio}`}
                  />
                </div>
              </div>
              <div className={styles.compilingPhaseImages}>
                <a
                  className={styles.compilingImgWrap}
                  href="https://bacardi.sharepoint.com/sites/FoundersDay2024ToolKits"
                  target="_blank"
                  rel="noreferrer"
                >
                  <div
                    className={`${styles.compilingPhaseImg} ${styles.selectionPhaseDownloadAssets}`}
                  />
                </a>

                <Link
                  className={styles.compilingImgWrap}
                  to="/ultimate-founders-winners"
                >
                  <div
                    className={`${styles.compilingPhaseImg} ${styles.selectionPhaseImgUFC}`}
                  />
                </Link>
                {/* <div className={styles.compilingImgWrap}>
                  <div
                    className={`${styles.compilingPhaseImg} ${styles.selectionPhaseImgQuest}`}
                  />
                </div> */}
              </div>
            </AnimatedContent>
          )}

          {!newsletterSent && sitePhase !== "Compiling" && (
            <div className={styles.rfcSubSection}>
              <AnimatedContent
                className={clsx(styles.title)}
                threshold={0.1}
                rootMargin={30}
              >
                {page}
              </AnimatedContent>

              <AnimatedContent threshold={0.1} rootMargin={30}>
                <div className={styles.ufcTextWrapper}>
                  {sitePhase === "Nomination" && (
                    <div className={styles.textTitle}>
                      Nominations Are Live!
                    </div>
                  )}
                  {sitePhase === "Compiling" && (
                    <div className={styles.textTitle}>Nominations Are In!</div>
                  )}
                  {sitePhase === "Voting" && (
                    // <div className={styles.textTitle}>Time to vote!</div>
                    <div className={styles.textTitle}>Vote Now!</div>
                  )}
                  {sitePhase === "Voting" && (
                    <>
                      <p className={styles.ufcText}>
                        The nominations are in, the shortlist is set, and now
                        it’s time to decide who will shine in this year’s
                        Ultimate Founders Competition!{" "}
                        <b>Voting is open until Friday, January&nbsp;16.</b>
                      </p>{" "}
                      <p className={styles.ufcText}>
                        Please note: You can cast only ONE vote per culture
                        pillar. Take a moment to reflect on the nominees and
                        choose who you feel best embodies each pillar.
                      </p>
                    </>
                  )}
                  {sitePhase !== "Voting" && (
                    <p className={styles.ufcText}>{text}</p>
                  )}

                  {sitePhase === "Nomination" && (
                    <div style={{ textAlign: "center", marginTop: "24px" }}>
                      <Button
                        onClick={() => {
                          navigate(url);
                        }}
                        auto={false}
                      >
                        {action}
                      </Button>
                    </div>
                  )}
                  {sitePhase === "Voting" && (
                    <div style={{ textAlign: "center", marginTop: "24px" }}>
                      <Button
                        onClick={() => {
                          navigate(url);
                        }}
                        auto={false}
                      >
                        {action}
                      </Button>
                    </div>
                  )}
                </div>
              </AnimatedContent>
            </div>
          )}
          <div className={styles.threeImagesSection}>
            {(sitePhase === "Nomination" ||
              sitePhase === "Compiling" ||
              sitePhase === "Voting") && (
              <AnimatedContent rootMargin={10} threshold={0.05}>
                <div className={styles.threeImages}>
                  <div className={`${styles.tagImgWrap} ${styles.tag1ImgWrap}`}>
                    <div className={`${styles.tag1Img} ${styles.tagImg}`} />
                    <div className={styles.tagImgTxt}>
                      Being fearless means having the courage to do the right
                      thing. It means adopting an agile mindset and being
                      comfortable with trying new things and taking risks,
                      without being reckless. We are all empowered to question,
                      challenge and innovate our business and the way we work.
                      Nothing gets in our way!
                    </div>
                  </div>
                  <div className={`${styles.tagImgWrap} ${styles.tag2ImgWrap}`}>
                    <div className={`${styles.tag2Img} ${styles.tagImg}`} />
                    <div className={styles.tagImgTxt}>
                      We treat each other, and our communities, like family.
                      Always. Being part of the extended Bacardi family gives
                      our people the support they need to be the best they can
                      be. We act as one team, keep our promises and stay humble.
                    </div>
                  </div>
                  <div className={`${styles.tagImgWrap} ${styles.tag3ImgWrap}`}>
                    <div className={`${styles.tag3Img} ${styles.tagImg}`} />
                    <div className={styles.tagImgTxt}>
                      The spirit of entrepreneurship is at the heart of
                      everything we do. We see this business as if it is our
                      own. We do what's right for the business and we all take
                      accountability for our work. We lean in and create. We
                      embrace questions before jumping to solutions.
                    </div>
                  </div>
                </div>

                {sitePhase === "Compiling" && (
                  <div className={styles.downloadAssetsWrap}>
                    <a
                      target="_blank"
                      rel="noopener noreferrer"
                      href="https://bacardi.sharepoint.com/sites/Founder'sDay2024/Founders%20Day%202026%20Assets/Forms/AllItems.aspx"
                    >
                      <div className={styles.downloadAssets} />
                    </a>
                  </div>
                )}
              </AnimatedContent>
            )}

            {!newsletterSent && action && (
              <div className={styles.buttonWrapper}>
                <Button
                  onClick={() => {
                    navigate(url);
                  }}
                  auto={false}
                  // classNames={styles.hoveredButton}
                  // onMouseEnter={() => setHovered(true)}
                  // onMouseLeave={() => setHovered(false)}
                >
                  {action}
                </Button>
              </div>
            )}
          </div>
        </div>
      )}
      {/* CHANGING EVERY YEAR!!!!! */}
      {false && sitePhase === "Compiling" && (
        <div className={styles.footerCollage}>
          <div className={styles.footerLeftCollage} />
          {sitePhase === "Compiling" && (
            <a
              target="_blank"
              rel="noopener noreferrer"
              href="https://bacardi.sharepoint.com/sites/Founder'sDay2024/Founders%20Day%202025%20Assets/Forms/AllItems.aspx"
            >
              <div className={styles.downloadAssets} />
            </a>
          )}
          <div className={styles.footerRightCollage} />
        </div>
      )}
      {(sitePhase === "Voting" || sitePhase === "Choosing") && (
        <div className={`${styles.footerCollage} ${styles.votingFooter}`}>
          <div className={styles.footerActions}>
            <a
              href="https://forms.office.com/Pages/ResponsePage.aspx?id=DngWnp1xa0mogCSsIMMKYHEAGsb3bthDm85QmMlvQzxUNUU4UEVGTzVRSU9WVjdQNDk1RzRTNFEyWS4u"
              target="_blank"
              rel="noopener noreferrer"
            >
              <div className={styles.submitPicsImg} />
            </a>
            <a
              href="https://bacardi.sharepoint.com/sites/Founder'sDay2024/Founders%20Day%202026%20Assets/Forms/AllItems.aspx"
              target="_blank"
              rel="noopener noreferrer"
            >
              <div className={styles.downloadAssetsImg} />
            </a>
            <a
              href="https://forms.office.com/Pages/ResponsePage.aspx?id=DngWnp1xa0mogCSsIMMKYHEAGsb3bthDm85QmMlvQzxURUtFWFNBQklNOTVCMDNCUks2SDJPSUZJRC4u"
              target="_blank"
              rel="noopener noreferrer"
            >
              <div className={styles.requestSongImg} />
            </a>
          </div>
          {/* <div className={styles.footerLeftCollage} /> */}
          {/* <div className={styles.footerRightCollage} /> */}
        </div>
      )}
      {sitePhase === "Selection" && false && (
        <div className={`${styles.footerCollage} ${styles.votingFooter}`}>
          <div className={styles.footerActions}>
            <a
              href="https://forms.office.com/Pages/ResponsePage.aspx?id=DngWnp1xa0mogCSsIMMKYHEAGsb3bthDm85QmMlvQzxUNUU4UEVGTzVRSU9WVjdQNDk1RzRTNFEyWS4u"
              target="_blank"
              rel="noopener noreferrer"
            >
              <div className={styles.submitPicsImg} />
            </a>
            <a
              href="https://forms.office.com/Pages/ResponsePage.aspx?id=DngWnp1xa0mogCSsIMMKYHEAGsb3bthDm85QmMlvQzxURUtFWFNBQklNOTVCMDNCUks2SDJPSUZJRC4u"
              target="_blank"
              rel="noopener noreferrer"
            >
              <div className={styles.requestSongImg} />
            </a>
            <a
              href="https://bacardi.sharepoint.com/sites/Founder'sDay2024/Founders%20Day%202026%20Assets/Forms/AllItems.aspx"
              target="_blank"
              rel="noopener noreferrer"
            >
              <div className={styles.downloadAssetsImg} />
            </a>
          </div>
          <div className={styles.footerLeftCollage} />
          <div className={styles.footerRightCollage} />
        </div>
      )}

      {sitePhase === "Selection" && (
        <div
          className={`${styles.footerCollage} ${styles.votingFooter} ${styles.selectionPhase}`}
        >
          <div className={styles.footerSelectionPhaseActions}>
            <div
              onClick={() => setShowScrapBook(true)}
              style={{ cursor: "pointer" }}
              className={styles.compilingImgWrap}
            >
              <div
                className={`${styles.compilingPhaseImg} ${styles.selectionPhaseImgScrapbook}`}
              />
            </div>
            <div
              className={styles.compilingImgWrap}
              onClick={() => setShowAudioRadio(true)}
              style={{ cursor: "pointer" }}
              // onClick={() => {}}
            >
              <div
                className={`${styles.compilingPhaseImg} ${styles.selectionPhaseImgRadio}`}
              />
            </div>

            <a
              className={styles.compilingImgWrap}
              // href="https://bacardi.sharepoint.com/sites/FoundersDay2024ToolKits"
              href="https://bacardi.sharepoint.com/sites/Founder'sDay2024/Founders%20Day%202025%20Assets/Forms/AllItems.aspx"
              target="_blank"
              rel="noreferrer"
            >
              <div
                className={`${styles.compilingPhaseImg} ${styles.selectionPhaseDownloadAssets}`}
              />
            </a>

            <Link
              className={styles.compilingImgWrap}
              to="/ultimate-founders-winners"
            >
              <div
                className={`${styles.compilingPhaseImg} ${styles.selectionPhaseImgUFC}`}
              />
            </Link>
          </div>
          <div className={styles.footerLeftCollage} />
          <div className={styles.footerRightCollage} />
        </div>
      )}

      <Popup
        buttons={[]}
        size="fullscreen"
        isShown={showScrapBook}
        handleClose={() => setShowScrapBook(false)}
        backgroundColor="#303030"
      >
        <div className={styles.popupContainer}>
          <iframe
            title="digital-scrapbook"
            src="https://indd.adobe.com/view/a6fec9eb-8cdb-410f-ac25-3fab9d42bab8"
            // src="https://indd.adobe.com/embed/a6fec9eb-8cdb-410f-ac25-3fab9d42bab8?startpage=1&allowFullscreen=true&toolbar=false"
            // src="https://indd.adobe.com/embed/8931102f-6c18-40b8-8db3-9dcefd49a038?startpage=1&allowFullscreen=true&toolbar=false"
            frameBorder="0"
            allowFullScreen=""
          ></iframe>
        </div>
      </Popup>

      <Popup
        buttons={[]}
        size="l"
        isShown={showAudioRadio}
        handleClose={() => setShowAudioRadio(false)}
        backgroundColor="#303030"
      >
        <VideoPlayer
          url="https://player.vimeo.com/video/1052980022?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479"
          isSelected
          isRadio
        />
      </Popup>

      {/* <Popup
        buttons={[]}
        size="radio"
        isShown={showAudioRadio}
        handleClose={() => setShowAudioRadio(false)}
        backgroundColor="#f1f3f4"
      >
        <div>
          <div className={styles.legacyRadioOn}></div>
          <ReactPlayer
            // url="/assets/audios/legacy-radio.mp3"
            url={legacyRadioUrl}
            controls
            playing
            width="100%"
            height="55px"
            // height="100%"
          />
        </div>
      </Popup> */}
    </div>
  );
};
